import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "steamdeal-wishlist";

function getStored(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function useWishlist() {
  const [list, setList] = useState<number[]>(getStored);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }, [list]);

  // 다른 탭에서 변경 시 동기화
  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setList(getStored());
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  const toggle = useCallback((appid: number) => {
    setList((prev) => prev.includes(appid) ? prev.filter((id) => id !== appid) : [...prev, appid]);
  }, []);

  const has = useCallback((appid: number) => list.includes(appid), [list]);

  return { list, toggle, has, count: list.length };
}
